<template>
    <div class="form-container">
        <MoneyField
            :max="maxLoanAmount"
            :maxlength="9"
            :min="minLoanAmount"
            :validationRules="validationRules"
            :label="$t('form.fields.loanAmount.label')"
            name="loanAmount"
            ref="loanAmount"
        />
    </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { maxLoanAmount, minLoanAmount } from '@js/utilities/loanDetails.js'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'loanAmount',
            hideContinue: false,
            route: {
                relativeUrl: `amount`,
                name: 'apply.loanDetails.amount',
                meta: {
                    title: 'form.sections.loanDetails.amount',
                },
            },
            fields: {
                loanAmount: {
                    value: null,
                    mappedKey: 'loan_amount',
                    legacyMappedKey: 'loan_amount_formatted',
                    formatterOnSummary: 'currencyFormat',
                    formatterOnQuery: 'numericFormatter',
                    validationRules: {
                        amountBetween: {},
                    },
                },
            },
        }
    },

    setup() {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()

        return {
            router,
            route,
            store,
        }
    },
    data() {
        return {
            loanAmountWatch: null,
        }
    },
    mounted() {
        this.autoFocus(this.$refs.loanAmount)

        this.emitter.emit('stepLoaded')
    },
    computed: {
        maxLoanAmount,
        minLoanAmount,
        loanTerm: function () {
            return this.store.getters.fieldValue('loanTerm')
        },
        loanAmount: function () {
            return this.store.getters.fieldValue('loanAmount')
        },
        validationRules: function () {
            return this.store.getters.fieldValidationRules('loanAmount')
        },
    },
}
</script>
